import PropTypes from 'prop-types';

export const SortOptionShape = {
    name: PropTypes.string,
    displayName: PropTypes.string,
    selected: PropTypes.bool
};

const PaginationStateShape = PropTypes.shape({ 
    resultsTotal: PropTypes.number,
    currentItemsPerPage: PropTypes.number,
    currentPageIndex: PropTypes.number,
    currentPageFirstItemIndex: PropTypes.number,
    currentItemsOnPage: PropTypes.number,
    sortOptions: PropTypes.arrayOf(PropTypes.shape(SortOptionShape))
})

export const PaginationPropShape = {
    pagination: PaginationStateShape,
    onCurrentSortByChange: PropTypes.func,
    onShowMobileFacetsToggle: PropTypes.func
};

const AttributeItemShape = PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    checked: PropTypes.bool,
    count: PropTypes.number
});

const AttributesStateShape = PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    values: PropTypes.arrayOf(AttributeItemShape),
    expanded: PropTypes.bool,
    showMore: PropTypes.bool
}));

export const AttributesParamShape ={
    attributes: AttributesStateShape,
    onToggleFacetExpanded: PropTypes.func,
    onAttributeChange: PropTypes.func, 
    onClearAttributes: PropTypes.func, 
    onToggleShowMoreFacet: PropTypes.func,
}

export const ResultShape = {
    results: PropTypes.arrayOf(PropTypes.object),
    onResultClick: PropTypes.func
}